export default __webpack_public_path__ + "img/fcd18a8c5474af12bb2bc3f1f7b74710.png";